import { randomNumber } from '../../../utilities'
import { getCurrentYear } from '../../../utilities/dateTime.util'
import { PatientImmunizationsConstants } from './patientImmunizations.constants'
import {
  IPatientImmunization,
  IPatientImmunizationAction,
  IPatientImmunizationsState,
} from './patientImmunizations.types'

export const initialPatientImmunization = (): IPatientImmunization => {
  return {
    key: randomNumber().toString(),
    immunizationType: null,
    year: { id: getCurrentYear(), name: getCurrentYear().toString() },
    otherName: null,
    upToDate: null,
  }
}

export const initialPatientImmunizationsState: IPatientImmunizationsState = {
  key: '',
  year: null,
  otherName: null,
  upToDate: null,
  immunizationType: null,
  immunizations: [{ ...initialPatientImmunization() }],
  immunizationStatus: null,
  immunizationIncompleteReason: null,
  immunizationStatusDate: null,
}

export function patientImmunizationsReducer(
  state: IPatientImmunizationsState = initialPatientImmunizationsState,
  action: IPatientImmunizationAction
): IPatientImmunizationsState {
  switch (action.type) {
    case PatientImmunizationsConstants.SET_YEAR:
      return { ...state, year: action.year, key: action.key }
    case PatientImmunizationsConstants.SET_OTHERNAME:
      return { ...state, otherName: action.otherName }
    case PatientImmunizationsConstants.SET_UPTODATE:
      return { ...state, upToDate: action.upToDate }
    case PatientImmunizationsConstants.SET_PATIENT_IMMUNIZATION_TYPE:
      return { ...state, immunizationType: action.immunizationType, key: action.key }
    case PatientImmunizationsConstants.SET_PATIENT_IMMUNIZATIONS_STATUS:
      return {
        ...state,
        immunizationStatus: action.immunizationStatus,
        immunizationStatusDate: action.immunizationStatusDate,
      }
    case PatientImmunizationsConstants.SET_PATIENT_IMMUNIZATIONS_INCOMPLETE_REASON:
      return { ...state, immunizationIncompleteReason: action.immunizationIncompleteReason }
    case PatientImmunizationsConstants.SET_IMMUNIZATIONS:
      return { ...state, immunizations: action.immunizations }
    case PatientImmunizationsConstants.SET_PATIENT_IMMUNIZATIONS:
      return { ...action.patientImmunizations }
    case PatientImmunizationsConstants.REMOVE_PATIENT_IMMUNIZATION:
      return { ...state, key: action.key }
    case PatientImmunizationsConstants.ADD_PATIENT_IMMUNIZATION_CARD:
      return {
        ...state,
        immunizations: [...state.immunizations, { ...initialPatientImmunization() }],
      }
    case PatientImmunizationsConstants.RESET_PATIENT_IMMUNIZATIONS:
      return {
        key: '',
        year: null,
        otherName: null,
        upToDate: null,
        immunizationType: null,
        immunizations: [{ ...initialPatientImmunization() }],
        immunizationStatus: null,
        immunizationIncompleteReason: null,
        immunizationStatusDate: null,
      }
    default:
      return state
  }
}
